import React, { useContext } from 'react'
import Button from '../../Button'
import { FieldsetContext, FormContext } from '../context'

interface IClearButtonProps {
  children: React.ReactNode
  icon?: React.ReactElement
  fullWidth?: boolean
  small?: boolean
  autoHide?: boolean
  hideTotalCount?: boolean
}

const ClearButton = ({
  children,
  icon,
  fullWidth,
  small,
  autoHide,
  hideTotalCount,
}: IClearButtonProps) => {
  const { form, ignore, deleteFormValue, setFormMetaData, formMetaData, setIsClearing } =
    useContext(FormContext)

  const { isInsideFieldset, inputs } = useContext(FieldsetContext)

  const clearForm = () => {
    setIsClearing(true)

    if (isInsideFieldset) {
      inputs.forEach(key => {
        deleteFormValue(key, false)
      })
    } else {
      Object.keys(form).forEach(key => {
        deleteFormValue(key, false)
      })
      setFormMetaData({ submitted: false })
    }
  }

  const variant = isInsideFieldset ? 'text-flat' : 'outlined-rounded'

  let totalCount = 0

  if (isInsideFieldset) {
    totalCount = inputs.reduce((total, fieldName) => {
      const count = Object.entries(formMetaData.formItems)
        .filter(([key]) => key.startsWith(fieldName))
        .filter(([key]) => !ignore.includes(key))
        .filter(([, value]) => value.hasValue === true).length

      return total + count
    }, 0)
  } else {
    totalCount = Object.entries(formMetaData.formItems).reduce((total, [key, value]) => {
      if (ignore.includes(key)) return total
      return total + (value.hasValue ? 1 : 0)
    }, 0)
  }

  const hideable = autoHide || isInsideFieldset

  if (hideable && totalCount === 0) return null

  return (
    <Button
      leadingIcon={icon}
      variant={variant}
      onClick={clearForm}
      size={isInsideFieldset || small ? 'small' : 'large'}
      fullWidth={fullWidth}
    >
      {children}
      {!hideTotalCount && <>&nbsp;({totalCount})</>}
    </Button>
  )
}

ClearButton.displayName = 'Form.ClearButton'
export default ClearButton
